/* Vegecore - manual discount-code entry for the cart page (#vcCartDisc) and cart drawer (#vcDrawerDisc).
   Uses the Cart AJAX API: POST /cart/update.js {discount:"CODE"} sets the cart's codes (replaces any existing),
   and cart.discount_codes[] reports {code, applicable}. Codes carry through to Shopify checkout.
   Note: the /cart/update.js response omits discount titles/amounts, so always re-read /cart.js before rendering totals.
   Added 2026-10-22. */
(function(){
  'use strict';
  function RM(c){return 'RM'+((c||0)/100).toFixed(2);}
  function esc(s){return String(s==null?'':s).replace(/[&<>"']/g,function(ch){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[ch];});}
  function getCart(){
    return fetch('/cart.js',{credentials:'same-origin',headers:{'Accept':'application/json'}})
      .then(function(r){if(!r.ok)throw new Error('cart '+r.status);return r.json();});
  }
  function setCodes(str){
    return fetch('/cart/update.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({discount:str})})
      .then(function(r){if(!r.ok)throw new Error('update '+r.status);return r.json();});
  }
  function appliedCodes(cart){return ((cart&&cart.discount_codes)||[]).filter(function(d){return d&&d.applicable;});}

  /* Apply one code. Codes on this store don't stack, so the new code replaces any existing one.
     If the new code isn't valid, the previous code(s) are restored so the customer doesn't lose them. */
  function apply(code){
    code=String(code||'').trim();
    if(!code)return Promise.resolve({ok:false,reason:'empty'});
    return getCart().then(function(before){
      var prev=appliedCodes(before).map(function(d){return d.code;}).join(',');
      return setCodes(code).then(function(cart){
        var hit=((cart.discount_codes)||[]).filter(function(d){return String(d.code).toLowerCase()===code.toLowerCase();})[0];
        if(hit&&hit.applicable)return getCart().then(function(fresh){return {ok:true,cart:fresh,code:hit.code};});
        return setCodes(prev).then(getCart).then(function(c2){return {ok:false,cart:c2,code:code,reason:'invalid'};});
      });
    });
  }
  function removeCode(code){
    return getCart().then(function(cart){
      var keep=appliedCodes(cart).filter(function(d){return String(d.code).toLowerCase()!==String(code).toLowerCase();}).map(function(d){return d.code;}).join(',');
      return setCodes(keep).then(getCart);
    });
  }

  var state={drawerOpen:false,busy:false};

  /* compact = cart drawer: the input stays collapsed behind a link so cart items keep their space. */
  function widgetHTML(cart,compact){
    var codes=appliedCodes(cart);
    var open=!compact||state.drawerOpen;
    var id=compact?'vcDiscInD':'vcDiscInC';
    var chips=codes.map(function(d){
      var c=esc(String(d.code).toUpperCase());
      return '<li class="vc-disc-chip"><span class="vc-disc-chip-ic" aria-hidden="true">%</span><span>'+c+' applied</span><button type="button" class="vc-disc-x" data-vc-disc-remove="'+esc(d.code)+'" aria-label="Remove code '+c+'">&times;</button></li>';
    }).join('');
    var h='<div class="vc-disc'+(compact?' vc-disc--compact':'')+'">';
    if(chips)h+='<ul class="vc-disc-chips">'+chips+'</ul>';
    if(compact)h+='<button type="button" class="vc-disc-toggle" data-vc-disc-toggle'+(open?' hidden':'')+'>'+(codes.length?'Use a different code':'Have a discount code?')+'</button>';
    h+='<div class="vc-disc-body"'+(open?'':' hidden')+'>'+
      '<label class="vc-disc-label" for="'+id+'">Discount code</label>'+
      '<div class="vc-disc-row"><input class="vc-disc-in" id="'+id+'" type="text" placeholder="Enter code" autocomplete="off" autocapitalize="characters" spellcheck="false" enterkeyhint="done"><button type="button" class="vc-disc-btn" data-vc-disc-apply>Apply</button></div>'+
    '</div>'+
    '<div class="vc-disc-msg" role="status" aria-live="polite"></div>'+
    '</div>';
    return h;
  }

  function setMsg(el,text,isErr){
    var m=el&&el.querySelector('.vc-disc-msg');
    if(!m)return;
    m.textContent=text||'';
    m.className='vc-disc-msg'+(text?(isErr?' is-err':' is-ok'):'');
  }

  function bind(el,onChange){
    if(el.__vcDisc){el.__vcDisc.onChange=onChange;return;}
    var ctx={onChange:onChange};
    el.__vcDisc=ctx;
    function go(){
      var inp=el.querySelector('.vc-disc-in');
      var btn=el.querySelector('[data-vc-disc-apply]');
      var code=inp?inp.value.trim():'';
      if(!code){setMsg(el,'Please enter a code.',true);if(inp)inp.focus();return;}
      if(state.busy)return;
      state.busy=true;
      if(btn){btn.disabled=true;btn.textContent='Applying...';}
      setMsg(el,'');
      apply(code).then(function(res){
        state.busy=false;
        if(res.ok){if(inp)inp.value='';state.drawerOpen=false;ctx.onChange(res.cart,{applied:res.code});return;}
        if(btn){btn.disabled=false;btn.textContent='Apply';}
        setMsg(el,'Sorry, "'+code.toUpperCase()+'" isn’t valid for the items in your cart.',true);
      }).catch(function(){
        state.busy=false;
        if(btn){btn.disabled=false;btn.textContent='Apply';}
        setMsg(el,'Something went wrong. Please try again, or enter the code at checkout.',true);
      });
    }
    el.addEventListener('click',function(e){
      if(e.target.closest('[data-vc-disc-apply]')){e.preventDefault();go();return;}
      var t=e.target.closest('[data-vc-disc-toggle]');
      if(t){
        e.preventDefault();state.drawerOpen=true;
        var b=el.querySelector('.vc-disc-body');if(b)b.hidden=false;
        t.hidden=true;
        var i=el.querySelector('.vc-disc-in');if(i)i.focus();
        return;
      }
      var x=e.target.closest('[data-vc-disc-remove]');
      if(x){
        e.preventDefault();
        if(state.busy)return;
        state.busy=true;x.disabled=true;
        removeCode(x.getAttribute('data-vc-disc-remove')).then(function(c){state.busy=false;ctx.onChange(c,{removed:true});})
          .catch(function(){state.busy=false;x.disabled=false;setMsg(el,'Couldn’t remove the code. Please try again.',true);});
      }
    });
    /* The cart page widget sits inside the cart <form>; stop Enter from submitting that form. */
    el.addEventListener('keydown',function(e){
      if(e.key==='Enter'&&e.target&&e.target.classList&&e.target.classList.contains('vc-disc-in')){e.preventDefault();go();}
    });
  }

  function togglePromo(promo,cart){if(promo)promo.hidden=appliedCodes(cart).length>0;}

  /* ---------- cart page ---------- */
  function initCartPage(){
    var el=document.getElementById('vcCartDisc');
    if(!el)return;
    bind(el,function(){location.reload();});
    getCart().then(function(cart){
      el.innerHTML=widgetHTML(cart,false);
      togglePromo(document.getElementById('vcCartPromo'),cart);
    }).catch(function(){});
  }

  /* ---------- cart drawer ---------- */
  function totalsHTML(cart){
    var cl=cart.cart_level_discount_applications||[];
    if(!cl.length)return '<div class="vc-sub"><span>Subtotal</span><span id="vcSubtotal">'+RM(cart.total_price)+'</span></div>';
    var h='<div class="vc-sub vc-sub--sm"><span>Subtotal</span><span id="vcSubtotal">'+RM(cart.items_subtotal_price)+'</span></div>';
    cl.forEach(function(d){h+='<div class="vc-disc-line"><span>Discount ('+esc(d.title)+')</span><span>&minus;'+RM(d.total_allocated_amount)+'</span></div>';});
    h+='<div class="vc-sub"><span>Total</span><span>'+RM(cart.total_price)+'</span></div>';
    return h;
  }
  function refreshDrawerItems(){
    var ic=document.querySelector('.nav-icon[aria-label="Cart"]');
    if(ic)ic.click();
  }
  function drawerUpdate(cart){
    var slot=document.getElementById('vcDrawerDisc');
    var tot=document.getElementById('vcDrawerTotals');
    if(!cart||!cart.item_count)return;
    if(slot){
      var inp=slot.querySelector('.vc-disc-in');
      var typed=inp?inp.value:'';
      var focused=!!(inp&&document.activeElement===inp);
      slot.innerHTML=widgetHTML(cart,true);
      bind(slot,function(c){drawerUpdate(c);refreshDrawerItems();});
      if(typed){var ni=slot.querySelector('.vc-disc-in');if(ni){ni.value=typed;if(focused)ni.focus();}}
    }
    if(tot)tot.innerHTML=totalsHTML(cart);
    togglePromo(document.getElementById('vcDrawerPromo'),cart);
  }
  function initDrawer(){
    var items=document.getElementById('vcDrawerItems');
    if(!items)return;
    var t=null;
    /* vc-additions.js re-renders #vcDrawerItems on every cart change; follow it. */
    new MutationObserver(function(){
      if(t)clearTimeout(t);
      t=setTimeout(function(){if(state.busy)return;getCart().then(drawerUpdate).catch(function(){});},60);
    }).observe(items,{childList:true});
  }

  window.VC_DISC={
    apply:apply,
    remove:removeCode,
    getCart:getCart,
    refreshDrawer:function(){return getCart().then(function(c){drawerUpdate(c);refreshDrawerItems();});},
    message:function(el,text,isErr){setMsg(el,text,isErr);}
  };

  function init(){initCartPage();initDrawer();}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();